





















































































import IGoodsMovementsDetail from '@/store/models/IGoodsMovementsDetail';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import moment from 'moment';

@Component({
    components: {
        Snackbar
    }
})
export default class GoodsMovementsDetailSelector extends Vue {
    searchMovementDetail: string = "";
    sortBy: string = 'goodName';
    sortDesc: boolean = false;
    dialogPrinting: boolean = false;
    selectedFormatToPrint: string = "excel";
    headers: any = [
        { text: 'Good',
            align: 'start',
            value: 'goodName'
        },
        { text: 'Inbound', value: 'codeInbounds' },
        { text: 'Total cases', value: 'casesPerPallet' },
        { text: 'Total goods', value: 'totalGoods' },
        { text: 'Pallet ID', value: 'idPallet' },
        { text: 'Best before date', value: 'bestBeforeDate' },
        { text: 'Reference dossier number', value: 'referenceInboundCode' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];

    @Prop({ type: Array, required: true })
    MovementDetailList !: IGoodsMovementsDetail[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedMovementDetail : IGoodsMovementsDetail[] = [];

    deleteMovementDetail (movement: IGoodsMovementsDetail) {
        if (this.selectedMovementDetail.length > 0) {
            this.$emit('deleteMovementDetail', movement);
        }
    }
     
    get MovementDetailListFiltered() : IGoodsMovementsDetail[] {
        return this.MovementDetailList.filter(
            (thing, i, arr) => arr.findIndex(t => t.idPallet === thing.idPallet) === i
        );
    }

    PrintMovementDetail(movement: IGoodsMovementsDetail) {
        this.dialogPrinting = false;
        this.$emit('printMovementDetail', movement, this.selectedFormatToPrint);
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    select(item : IGoodsMovementsDetail) : void {
        let index : number = this.selectedMovementDetail.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedMovementDetail = [item];
        } else {
            let movementDetail = this.selectedMovementDetail.find(w => w.id === item.id);
            if (!movementDetail) {
                this.selectedMovementDetail = [];
            }
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
